import UNIT_TYPES from "../../../configs/units";
import {checkIfUnitMeleeElf} from "../../factions/elves/checkIfUnitMeleeElf";
import {calculateAvailableShootingCellsForElves} from "../../factions/elves/calculateAvailableShootingCellsForElves";
import {hasAdjacentEnemyUnit} from "../hasAdjacentEnemyUnit";
import {calculateAvailableShootingCells} from "../shooting/calculateAvailableShootingCells";
import {
  selectBuildingsDamage,
  selectCitiesCache,
  selectFortressesUnderConstruction,
  selectHexes,
  selectSpecialBuildings,
  selectUnits
} from "../../../redux/reducers/sharedStateReducer/selectors";

/**
 * Может ли отряд игрока стрелять прямо сейчас: D4 или боевые эльфы, не зажатые
 * вплотную врагом, с хотя бы одной доступной целью. Общая проверка для перехода
 * между этапами (handleCompleteTurn) и подсчета дел этапа стрельбы — чтобы
 * кнопка хода и открытие этапа не разъезжались при правке правил стрельбы.
 *
 * Игрок передается явно: монеты и цвет берутся у него, а не из состояния.
 * pendingShootingActions — уже заявленные выстрелы этапа (их цели учитываются
 * как поврежденные); для перехода между этапами выстрелов еще нет.
 */
export const checkIfUnitCanShoot = (state, unit, player, {pendingShootingActions = []} = {}) => {
  const isMeleeElf = checkIfUnitMeleeElf(unit);
  if (unit.type !== UNIT_TYPES.D4.id && !isMeleeElf) return false;

  const units = selectUnits(state);
  if (hasAdjacentEnemyUnit(unit.hexKey, player.id, units)) return false;

  const hexes = selectHexes(state);
  const specialBuildings = selectSpecialBuildings(state);
  const buildingsDamage = selectBuildingsDamage(state);
  const fortressesUnderConstruction = selectFortressesUnderConstruction(state);

  const availableTargets = isMeleeElf
    ? calculateAvailableShootingCellsForElves(
      hexes,
      units,
      unit,
      pendingShootingActions,
      specialBuildings,
      buildingsDamage,
      fortressesUnderConstruction,
    )
    : calculateAvailableShootingCells(
      hexes,
      units,
      unit,
      pendingShootingActions,
      selectCitiesCache(state),
      player,
      specialBuildings,
      buildingsDamage,
      fortressesUnderConstruction,
    );

  return availableTargets.length > 0;
};
